/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'fabric.elements.mentions.team.member.50plus': '团队 • 50 多名成员',
  'fabric.elements.mentions.team.member.50plus.including.you': '团队 • 50 多名成员，包括您',
  'fabric.elements.mentions.team.member.count': '{0, plural, other {团队 • {0} 名成员}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, other {团队 • {0} 名成员，包括您}}',
  'fabric.elements.mentions.xproduct.mention.description': '需要访问 Confluence',
  'fabric.mention.error.defaultAction': '几秒钟后再试一次',
  'fabric.mention.error.defaultHeadline': '出错了',
  'fabric.mention.error.differentText': '尝试输入不同的文本',
  'fabric.mention.error.loginAgain': '尝试再次退出',
  'fabric.mention.noAccess.label': '无法访问',
  'fabric.mention.noAccess.warning': '将不会通知{name}，因为他们无访问访问权限',
  'fabric.mention.unknow.user.error': '未知用户 {userId}'
};